import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { formatDate } from '../utils/dateFormatter';

const STATUS_CONFIG = {
  pending: {
    bg: 'warning',
    label: 'قيد الانتظار',
    emoji: '🟡'
  },
  assigned: {
    bg: 'info',
    label: 'تم التعيين',
    emoji: '🔵'
  },
  'in-progress': {
    bg: 'primary',
    label: 'قيد التنفيذ',
    emoji: '⚡'
  },
  completed: {
    bg: 'success',
    label: 'مكتملة',
    emoji: '✅'
  },
  cancelled: {
    bg: 'secondary',
    label: 'ملغية',
    emoji: '❌'
  }
};

/**
 * Simple Read-only Task Card for Property Owners
 * Minimal details - just status, date, and title
 */
const OwnerTaskCard = ({ task }) => {
  const statusConfig = STATUS_CONFIG[task.status] || STATUS_CONFIG.pending;
  const isOverdue = task.isOverdue && task.status !== 'completed' && task.status !== 'cancelled';

  return (
    <Card className="mb-2 border-0 shadow-sm owner-task-card" dir="rtl">
      <Card.Body className="py-3 px-3">
        {/* Status and Title Row */}
        <div className="d-flex align-items-center flex-wrap mb-2" dir="rtl" style={{ gap: '8px' }}>
          <span style={{ fontSize: '1.3rem' }}>{statusConfig.emoji}</span>
          <Badge bg={statusConfig.bg}>
            {statusConfig.label}
          </Badge>
          {isOverdue && (
            <Badge bg="danger">متأخر</Badge>
          )}
          <span className="fw-semibold" style={{ flex: '1 1 auto', minWidth: '120px' }}>{task.title}</span>
        </div>

        {/* Date and Time Row */}
        <div className="text-muted small d-flex align-items-center" dir="rtl" style={{ gap: '6px' }}>
          <span>اليوم</span>
          <strong className="text-dark">📅 {formatDate(task.scheduledDate)}</strong>
          {task.scheduledTime && (
            <>
              <span>-</span>
              <span>{task.scheduledTime}</span>
            </>
          )}
        </div>

        {/* Notes (only if present) */}
        {task.notes && (
          <div className="mt-2 pt-2 border-top">
            <small className="text-muted">{task.notes}</small>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default OwnerTaskCard;
